import { useGetOrderQuantity } from 'api/dashboardApi';
import _ from 'lodash';
import ColumnChart from '../ColumnChart';

function normalizeData(data) {
  return _.map(data, (value, key) => ({
    name: _.capitalize(key),
    value,
  }));
}

export default function OrderQuantityBlock() {
  const { data, isLoading } = useGetOrderQuantity({
    options: {
      select: (response) => normalizeData(response),
    },
  });

  if (isLoading) {
    return null;
  }

  return <ColumnChart data={data} title="Số lượng order" />;
}
